import styled from 'styled-components';

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;

  & > div:first-child {
    margin-right: 8px;
  }

  & > div:last-child {
    max-width: 1000px;
    word-break: break-word;
  }
`;
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  & > div:last-child > div:first-child {
    .ant-btn {
      border-color: ${({ theme }) => theme.colors.tone.red};
      color: ${({ theme }) => theme.colors.tone.red};
    }
  }
`;
